import styled from 'styled-components';
import color from '../../../config/colors.json';

export const StyledH2 = styled.h2`
    font-family: 'Poppins', Arial, Helvetica, sans-serif;
    font-size: 15px;
    line-height: 21px;
    text-align: left;
    color: ${color.darkGrey};
    font-weight: 600;
	margin: 0;
`;
